var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinalise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 4.66658L4.33333 4.66659M8.5 11.3333L4.33333 11.3333M16 1.33325L11.8333 5.49992L10.1667 3.83325M16 7.99992L11.8333 12.1666L10.1667 10.4999M2.66667 4.66659C2.66667 5.12682 2.29357 5.49992 1.83333 5.49992C1.3731 5.49992 1 5.12682 1 4.66659C1 4.20635 1.3731 3.83325 1.83333 3.83325C2.29357 3.83325 2.66667 4.20635 2.66667 4.66659ZM2.66667 11.3333C2.66667 11.7935 2.29357 12.1666 1.83333 12.1666C1.3731 12.1666 1 11.7935 1 11.3333C1 10.873 1.3731 10.4999 1.83333 10.4999C2.29357 10.4999 2.66667 10.873 2.66667 11.3333Z",
    stroke: "#344054",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinalise);
export default __webpack_public_path__ + "static/media/finalise.e66ec769c97d48c746f650d5e3d8b14e.svg";
export { ForwardRef as ReactComponent };